import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, VivaService } from '../_services';
import { Globals } from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-vivalist',
    templateUrl: './vivalist.component.html'
})


export class VivalistComponent implements OnInit {
    [x: string]: any;
    marksFormControl = new FormControl('', [
        Validators.required,
    ]);
    matcher = new MyErrorStateMatcher();

    statusMsg: string = '';
    batch_name: string = '';
    exam_name: string = '';
    exam_date;
    localData = {};
    localBatch = {};
    localStudent = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    vivaData = [];
    query: string = '';
    examId: number;

    studentId: number;
    questionid: number;
    private sub: any;
    public pause = true;
    isAudio = false;
    mediaSrc: string;
    @ViewChild("videoPlayer") videoplayer: ElementRef;
    // pause: boolean=true;
   

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private vivaService: VivaService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) { }

    ngOnInit() {
        /* get parameter query */
        this.sub = this.route.params.subscribe(params => {
            this.studentId = +params['id'];
        });

        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.localBatch = JSON.parse(localStorage.getItem('localBatch'));
        this.getStudentVivaData();

        this.batch_name = this.localBatch['batch_name'];
        this.exam_name = this.localBatch['exam_name'];
        this.exam_date = this.localBatch['exam_date'];
    }

    private getStudentVivaData() {
        this.spinner.show();
        this.submitted = true;
        this.vivaService.getStudentViva(this.globals.root_url, this.localData['usercode'], this.localBatch['batchId'], this.studentId)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.vivaData = data.vivaData;
                        this.examId = data.exam_id;
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
                    else {
                        this.loading = false;
                        this.globals.statusOpen(data.status, '/proctor-view/students');
                    }
                    this.spinner.hide();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }


    public onSubmit(question_id: any) {
        if (this.marksFormControl.value == '' || question_id == '') {
            this.globals.statusOpen('Please enter marks!');
        }
        else {
            this.spinner.show();
            this.submitted = true;
            this.vivaService.setVivaMarks(this.globals.root_url, this.localData['usercode'], this.studentId, question_id, this.marksFormControl.value, this.examId)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.setUpdatedMarks(question_id, this.marksFormControl.value);
                            this.editMarksHide(question_id);
                        }
                        else if (data.status == 'COM_TOKEN_ERROR') {
                            this.loading = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.loading = false;
                            this.globals.statusOpen(data.status);
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }

    public setUpdatedMarks(quest_id: number, marks: string) {
        var htmlText = document.getElementById('marks_text_' + quest_id);
        htmlText.innerHTML = marks;
    }

    public editMarksShow(quest_id: number) {
        // var labelHtml = document.getElementById('label_'+quest_id);
        var formHtml = document.getElementById('form_' + quest_id);
        // labelHtml['style'].display = 'none';
        formHtml['style'].display = 'block';
    }

    public editMarksHide(quest_id: number) {
        var labelHtml = document.getElementById('label_' + quest_id);
        var formHtml = document.getElementById('form_' + quest_id);
        labelHtml['style'].display = 'block';
        formHtml['style'].display = 'none';
    }

    public mediaOpen(url: string, type: string) {
        if (type == 'audio')
            this.isAudio = true;
        else
            this.isAudio = false;

        this.mediaSrc = url;
        let vmodal = document.getElementById('vmodal');
        vmodal.style.display = 'block';

    }

    public mediaClose() {
        let vmodal = document.getElementById('vmodal');
         
        this.videoplayer.nativeElement.pause();
        this.videoplayer.nativeElement.currentTime = 0;


        vmodal.style.display = 'none';


    }

    // public toggleVideo() {
    //     this.videoplayer.pause()
    //      
    //     // this.pause = !this.pause;
    // }

    // toggleVideo() {
    //     var myVideo: any = document.getElementById("vmodal");
    //      
    //     if (myVideo.paused) myVideo.play();
    //     else myVideo.pause(); 
    
    // }

    toggleVideo(event: any) {
        this.videoplayer.nativeElement.pause();
    }
}


